import { createContext, useContext, useState } from 'react'
import { supabase } from '../supabase/client';

export const OptionsModalitiesContext = createContext();

export const useOptionsModalities = () => {
    const context = useContext(OptionsModalitiesContext);
    if (!context) {
        throw new Error('useOptionsModalities debe estar dentro del proveedor OptionsModalitiesContext')
    }
    return context;
};

export const OptionsModalitiesContextProvider = ({ children }) => {
    const [optionsModalities, setOptionsModalities] = useState([])
    const [modal, setModal] = useState(false)

    const getModal = () => {
        setModal(false)
    }

    const getOptionsModalities = async () => {
        const { error, data } = await supabase
            .from('modality_options')
            .select('id, name')
            .order('name', { ascending: true })
        if (error) throw (error.message)
        setOptionsModalities(data)
    }

    const getOptionsModality = async (id) => {
        const { error, data } = await supabase
            .from('modality_options')
            .select()
            .eq('id', id)
            .single()
        if (error) throw (error.message)
        return data
    }

    // const createSpecialty = async (formData) => {
    //     const { error, status, statusText } = await supabase
    //         .from('optionsmodalities')
    //         .insert(formData)
    //         .select()
    //     if (status !== 201) return {
    //         title: statusText,
    //         msg: error.message + " Code:[" + error.code + "]",
    //         icon: 'error',
    //         code: status
    //     }
    //     await getoptionsModalities()
    //     setModal(true)
    //     return {
    //         title: statusText,
    //         msg: "Registro creado correctamente",
    //         icon: 'success',
    //         code: status
    //     }
    // }

    // const updateSpecialty = async (formData, id) => {
    //     try {
    //         const { error, status, statusText } = await supabase
    //             .from('optionsmodalities')
    //             .update(formData)
    //             .eq('id', id)
    //             .select()
    //         if (status !== 200) return {
    //             title: statusText,
    //             msg: error.message + " Code:[" + error.code + "]",
    //             icon: 'error'
    //         }
    //         await getoptionsModalities()
    //         setModal(true)
    //         return ({
    //             title: statusText,
    //             msg: 'Registro actualizado correctamente',
    //             icon: 'success'
    //         })
    //     } catch (e) {
    //         console.error(e)
    //     }
    // }


    return (
        <OptionsModalitiesContext.Provider value={{
            optionsModalities,
            modal,
            getOptionsModalities,
            getOptionsModality,
            // createSpecialty,
            // updateSpecialty,
            getModal
        }}>
            {children}
        </OptionsModalitiesContext.Provider>
    )
}